import { render, staticRenderFns } from "./SegmentDurationSelector.vue?vue&type=template&id=71c82477&scoped=true"
import script from "./SegmentDurationSelector.vue?vue&type=script&lang=js"
export * from "./SegmentDurationSelector.vue?vue&type=script&lang=js"
import style0 from "./SegmentDurationSelector.vue?vue&type=style&index=0&id=71c82477&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c82477",
  null
  
)

export default component.exports